/**
 * @name userMenuSearch
 * @module flowingly.user.menu
 * @description display search on user menu
 * ### Notes
 * 
 * @usage
 * ```
    <user-menu-search></user-menu-search>
 * ```
 */
import angular from 'angular';
import UserMenuSearchBridge from './UserMenuSearchBridge';

angular
  .module('flowingly.user.menu')
  .component('userMenuSearch', UserMenuSearchBridge);
